import { EpgCategory } from './EpgCategory';
import { EpgChannel, ITypeChannelsCollection } from './EpgChannel';
import { EpgChannelGenre } from './EpgChannelGenre';
import { EpgProgram, ITypeProgramsCollection } from './EpgProgram';
import { EpgProgramGenre } from './EpgProgramGenre';
import { ChannelGroup, IChannelGroup } from './ChannelGroup';
import List from "./lib/List";
import { IChannelsGroupedResponse } from "Responses";

export class EpgParser {
  public static parseChannelsData(
    data: {channel_groups: IChannelsGroupedResponse[]},
  ): [ITypeChannelsCollection, List<IChannelGroup>] {
    const resultChannels: ITypeChannelsCollection = {};
    const orderedChannels = new List<IChannelGroup>();
    if (data.channel_groups) {
      const groups = data.channel_groups;
      const channelsNeedToUpdate: { [key: string]: EpgChannel } = {};

      for (let i: number = 0, l: number = groups.length; i < l; ++i) {
        const group = groups[i];
        const genre = new EpgChannelGenre(group.type_id, group.type_name);
        const channels = group.objects;
        const channelGroup = new ChannelGroup(genre);
        orderedChannels.push(channelGroup);

        for (let j: number = 0, k: number = channels.length; j < k; ++j) {
          channelGroup.channels.push(channels[j].id);
          if (!(channels[j].id in resultChannels)) {
            const newChannel = new EpgChannel(
              channels[j],
              !genre.isFavorite && !genre.isFeatured ? genre : undefined,
            );
            newChannel.isFavorite = genre.isFavorite;
            newChannel.isFeatured = genre.isFeatured;
            resultChannels[newChannel.id] = newChannel;
            if (genre.isFavorite || genre.isFeatured) {
              channelsNeedToUpdate[newChannel.id] = newChannel;
            }
          } else if (
            channels[j].id in channelsNeedToUpdate &&
            !genre.isFavorite &&
            !genre.isFeatured
          ) {
            channelsNeedToUpdate[channels[j].id].originalGenre = genre;
          }
        }
      }
    }
    return [resultChannels, orderedChannels];
  }

  public static parseProgramsData(
    data: any,
    isExtended: boolean = false,
    channelId: number = 0,
  ): ITypeProgramsCollection {
    const result: ITypeProgramsCollection = {};
    let program: EpgProgram | null;
    if (data && data.length > 0) {
      for (let i: number = 0, l: number = data.length; i < l; ++i) {
        if (data[i] && data[i].id > 0) {
          if (!result[data[i].id]) {
            result[data[i].id] = {
              programs: [],
              isExtended,
            };
          }
          for (
            let j: number = 0, k: number = data[i].programs.length;
            j < k;
            ++j
          ) {
            program = EpgParser.createProgramObject(data[i].programs[j]);
            if (program) {
              result[data[i].id].programs.push(program);
            }
          }
        }
      }
    } else if (isExtended && channelId > 0) {
      result[channelId] = { programs: [], isExtended };
    }

    return result;
  }

  private static createProgramObject(programData: any): EpgProgram | null {
    let result: EpgProgram | null = null;
    if (
      programData &&
      typeof programData.start_timestamp === 'number' &&
      typeof programData.end_timestamp === 'number'
    ) {
      result = new EpgProgram(programData);
    }
    return result;
  }
}
